export class FirebaseServiceStub {
  fetchOffset() {
    return 0;
  }
}
